module.exports = __webpack_public_path__ + "img/payment-wechat.5673aec8.png";